/**
 * First we will load all of this project's JavaScript dependencies which
 * includes React and other helpers. It's a great starting point while
 * building robust, powerful web applications using React + Laravel.
 */

import './bootstrap';

/**
 * Next, we will create a fresh React component instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

import { createApp } from 'vue'

import Notification from './components/Notification.vue'
import Chat from "./components/Chat.vue";
import Inbox from "./components/Inbox.vue";
// import Activity from "./components/Activity.vue";
// import NotificationTable from "./components/NotificationTable.vue";

import NeoRtc from "../../../app/Modules/Chat/Resources/assets/js/neo-rtc"

window.NeoRtcInstance = NeoRtc


const headerApp = createApp({})


headerApp.component('Notification', Notification)
headerApp.component('Chat', Chat)
headerApp.component('Inbox', Inbox)
headerApp.mount('#header-app')

window.vueHeaderApp = headerApp

